module.exports = __webpack_public_path__ + "69e5b9043f7f3fbfa565429113f736a5.png";